import React from "react";
import { Route, Routes } from "react-router-dom";
import SuperAdminIndex from "./index";
import SuperAdminDashboard from "./SuperAdminDashboard";
import CustomerManagement from "./pages/CustomerManagement";
import ServiceManagement from "./pages/ServiceManagement";
import OrdersPage from "./pages/OrdersPage";
import DownloadComponent from "./pages/DownloadComponent";
import UDharPage from './pages/UDharPage';

export default function DevRoute() {
  return (
    <>
      <Routes>
        <Route path="/" element={<SuperAdminIndex />}>
          <Route index path="/" element={<SuperAdminDashboard />} />
          <Route path="dashboard" element={<SuperAdminDashboard />} />
          <Route path="customer" element={<CustomerManagement />} />
          <Route path="service" element={<ServiceManagement />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="download" element={<DownloadComponent />} />
          <Route path="udhar" element={<UDharPage />} />
          <Route path="*" element={<SuperAdminDashboard />} />
        </Route>
      </Routes>
    </>
  );
}
